import Axios from 'axios'
import { apiUrl } from '@/utils/util'

//添加响应拦截器
Axios.interceptors.response.use(response => { //响应数据执行方法
	return response.data
}, error => {
	return(error.response)
});

Axios.defaults.baseURL = apiUrl + "/api/domain";

export default Axios;